if (!window.ziloopProductionAudioBound) {
  window.ziloopProductionAudioBound = true;

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-ziloop-sound-toggle]');
    if (!button) return;

    const media = button.closest('.ziloop-production-video__featured-media');
    const video = media && media.querySelector('video');
    if (!video) return;

    video.muted = !video.muted;
    if (!video.muted) video.volume = 1;
    button.setAttribute('aria-pressed', String(!video.muted));
    const label = button.querySelector('[data-ziloop-sound-label]');
    if (label) label.textContent = video.muted ? 'Enable sound' : 'Mute sound';

    if (!video.muted && video.paused) {
      video.play().catch(() => {});
    }
  });
}


if (!window.ziloopProductionCaptionsBound) {
  window.ziloopProductionCaptionsBound = true;

  document.querySelectorAll('[data-ziloop-captions-src]').forEach((media) => {
    const video = media.querySelector('video');
    const source = media.dataset.ziloopCaptionsSrc;
    if (!video || !source) return;

    const display = document.createElement('div');
    display.className = 'ziloop-production-video__captions';
    display.setAttribute('role', 'status');
    display.setAttribute('aria-live', 'polite');
    display.setAttribute('aria-label', 'English video subtitles');
    media.appendChild(display);

    const toSeconds = (stamp) => {
      const match = stamp.match(/(?:(\d+):)?(\d{2}):(\d{2})\.(\d{3})/);
      if (!match) return 0;
      return (Number(match[1] || 0) * 3600) + (Number(match[2]) * 60) + Number(match[3]) + (Number(match[4]) / 1000);
    };

    fetch(source, { credentials: 'same-origin' })
      .then((response) => {
        if (!response.ok) throw new Error('Subtitle file could not be loaded');
        return response.text();
      })
      .then((webvtt) => {
        const cues = webvtt.replace(/^\uFEFF/, '').split(/\r?\n\s*\r?\n/).flatMap((chunk) => {
          const lines = chunk.trim().split(/\r?\n/);
          const timing = lines.findIndex((line) => line.includes('-->'));
          if (timing < 0) return [];
          const times = lines[timing].split('-->').map((part) => part.trim().split(/\s+/)[0]);
          return [{ start: toSeconds(times[0]), end: toSeconds(times[1]), text: lines.slice(timing + 1).join('\n') }];
        });

        let activeCue = -1;
        const updateCaption = () => {
          if (video.paused || video.ended) {
            activeCue = -1;
            display.textContent = '';
            return;
          }
          const time = video.currentTime;
          const nextCue = cues.findIndex((cue) => time >= cue.start && time <= cue.end);
          if (nextCue === activeCue) return;
          activeCue = nextCue;
          display.textContent = nextCue >= 0 ? cues[nextCue].text : '';
        };

        video.addEventListener('timeupdate', updateCaption);
        video.addEventListener('seeked', updateCaption);
        video.addEventListener('play', updateCaption);
        video.addEventListener('pause', updateCaption);
        video.addEventListener('ended', updateCaption);
        video.addEventListener('loadedmetadata', updateCaption, { once: true });
        updateCaption();
      })
      .catch((error) => console.warn('[ZILOOP captions]', error));
  });
}
